module.exports = __webpack_public_path__ + "img/d-fbom-cn.4a2778de.gif";